module.exports = __webpack_public_path__ + "img/image00014.c29bf884.jpeg";